import { styled } from 'linaria/react';
import { cx } from 'linaria';
import React, { useEffect, useRef, useState } from 'react';

const FacetAccordionWrapper = styled('div')`
  .titleRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 16px 0;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    text-transform: uppercase;
    svg {
      width: 20px;
    }
  }

  .elevate-facet-accordion-content {
    overflow: hidden;

    .elevate-facet-accordion-content-spacer {
      height: 28px;
    }
  }

  svg {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    transform: rotate(0deg);
  }
  svg.isOpen {
    transform: rotate(180deg);
  }
`;

export const ElevateFacetAccordion = ({
  children,
  title,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const innerRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setContentHeight(0);
      return;
    }
    setContentHeight(innerRef.current?.scrollHeight ?? 0);
  }, [isOpen, children]);

  // Save state to sessionStorage whenever it changes
  // useEffect(() => {
  //   sessionStorage.setItem(storageKey, isOpen.toString());
  // }, [isOpen, storageKey]);

  return (
    <FacetAccordionWrapper>
      <div
        className={cx('titleRow', isOpen && 'isOpen')}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={cx('icon', isOpen && 'isOpen')}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>
      <div
        className="animate-height elevate-facet-accordion-content"
        style={{ height: `${contentHeight}px` }}
      >
        <div ref={innerRef}>
          {children}
          <div className="elevate-facet-accordion-content-spacer"></div>
        </div>
      </div>
    </FacetAccordionWrapper>
  );
};
